<div class="rounded-2xl border border-gray-300 bg-white overflow-hidden">

  <mat-tab-group
    animationDuration="200ms"
    (selectedIndexChange)="onTabChange($event)"
    class="w-full"
  >

    <!-- Page Alerts Tab -->
    <mat-tab label="Page Alerts">
      <ng-template matTabContent>

        <div class="p-4 md:p-6">

          <div class="mb-4 flex items-center justify-between">
            <h2 class="text-base md:text-lg font-semibold text-gray-900 tracking-tight">
              Page Alerts
            </h2>
          </div>

          <div class="rounded-xl bg-white overflow-hidden">
            <app-social-ai-alerts-chart
              *ngIf="activeTab === 'page'"
              [selectedSiteId]="selectedSiteId"
              [selectedPlatformId]="selectedPlatformId"
              [pages]="pages"
              title="Page Alerts"
              [isPageAlerts]="true"
              [selectedAlertType]="selectedAlertType"
              class="block w-full"
            >
            </app-social-ai-alerts-chart>
          </div>

        </div>

      </ng-template>
    </mat-tab>


    <!-- Post Alerts Tab -->
    <mat-tab label="Post Alerts">
      <ng-template matTabContent>

        <div class="p-4 md:p-6">

          <div class="mb-4 flex items-center justify-between">
            <h2 class="text-base md:text-lg font-semibold text-gray-900 tracking-tight">
              Post Alerts
            </h2>
          </div>

          <div class="rounded-xl bg-white overflow-hidden">
            <app-social-ai-alerts-table
              *ngIf="activeTab === 'table'"
              [selectedSiteId]="selectedSiteId"
              [selectedPlatformId]="selectedPlatformId"
              [selectedFormat]="selectedFormat"
              [selectedAlertType]="selectedAlertType"
              [pages]="pages"
              title="Post Alerts"
              class="block w-full"
            >
            </app-social-ai-alerts-table>
          </div>

        </div>

      </ng-template>
    </mat-tab>

  </mat-tab-group>

</div>